import { useEffect, useId } from "react";
import { Tooltip } from "bootstrap";
import infoIcon from "@assets/icons/info.svg?raw&inline";

const InfoIcon = () => {
  return (
    <span
      style={{ width: 15 }}
      className="d-flex align-items-center text-muted size-14 cursor-pointer ms-1"
      dangerouslySetInnerHTML={{ __html: infoIcon }}
    />
  );
};

export const CustomTooltip = ({
  label,
  text,
}: {
  label?: React.ReactNode;
  text: string;
}) => {
  const tooltipId = useId();
  useEffect(() => {
    const tooltip = Tooltip.getOrCreateInstance(
      document.getElementById(tooltipId) as HTMLElement
    );
    tooltip.enable();
    return () => {
      tooltip.dispose();
    };
  }, [tooltipId]);
  return (
    <span
      id={tooltipId}
      className="ms-1 d-inline-flex align-items-center"
      data-bs-toggle="tooltip"
      data-bs-placement="bottom"
      title={text}
    >
      {label || <InfoIcon />}
    </span>
  );
};
